import { Titles } from "../constants";
import {
  EndPoint,
  RecommendationType,
  RecommendationVariants,
  RecommendedType,
} from "../enums";

export const recommendationConfig = {
  [RecommendationType.ADS]: {
    title: Titles.TOP_PICKS_FOR_YOU,
    recommendedType: RecommendedType.USER_BASED,
    recommendationVariant: RecommendationVariants.TOP_PICKS,
    showLeftIcon: true,
    showSeeAll: true,
    showClose: false,
    endPoint: EndPoint.search,
    pagename: '',
    sourceEvent: '',
  },

  [RecommendationType.AGEING]: {
    title: Titles.TOP_PICKS_FOR_YOU,
    recommendedType: RecommendedType.USER_BASED,
    recommendationVariant: RecommendationVariants.TOP_PICKS,
    showLeftIcon: true,
    showSeeAll: true,
    showClose: false,
    endPoint: EndPoint.search,
    pagename: '',
    sourceEvent: '',
  },

  [RecommendationType.BASKET]: {
    title: Titles.FREQUENTLY_BOUGHT,
    recommendedType: RecommendedType.USER_BASED,
    recommendationVariant: RecommendationVariants.BASKET,
    showLeftIcon: true,
    showSeeAll: true,
    showClose: false,
    endPoint: EndPoint.recommendation,
    pagename: 'basketRecommendation',
    sourceEvent: 'basketRecommendationCarousel',
  },

  [RecommendationType.BOUGHT_TOGETHER]: {
    title: Titles.BOUGHT_TOGETHER,
    recommendedType: RecommendedType.PRODUCT_BASED,
    recommendationVariant: RecommendationVariants.FREQUENTLY_BOUGHT_TOGETHER,
    showLeftIcon: false,
    showSeeAll: false,
    showClose: true,
    endPoint: EndPoint.recommendation,
    pagename: 'boughtTogether',
    sourceEvent: 'plpboughtTogetherCarousel',
  },

  [RecommendationType.BRANDS]: {
    title: Titles.BRANDS,
    recommendedType: RecommendedType.USER_BASED,
    recommendationVariant: RecommendationVariants.BRANDS,
    showLeftIcon: true,
    showSeeAll: true,
    showClose: false,
    endPoint: EndPoint.search,
    pagename: 'brandRecommendations',
    sourceEvent: 'pdpBrandRecommendationsCarousel',
  },

  [RecommendationType.CATEGORIES]: {
    title: Titles.CATEGORY,
    recommendedType: RecommendedType.USER_BASED,
    recommendationVariant: RecommendationVariants.CATEGORIES,
    showLeftIcon: true,
    showSeeAll: true,
    showClose: false,
    endPoint: EndPoint.search,
    pagename: 'categoryRecommendations',
    sourceEvent: 'pdpCategoryRecommendationsCarousel',
  },

  [RecommendationType.FRESHFOOD]: {
    title: Titles.FRESH_FOOD,
    recommendedType: RecommendedType.USER_BASED,
    recommendationVariant: RecommendationVariants.FRESH_FOOD,
    showLeftIcon: true,
    showSeeAll: true,
    showClose: false,
    endPoint: EndPoint.recommendation,
    pagename: 'freshRecommendations',
    sourceEvent: 'freshRecommendationsCarousel',
  },

  [RecommendationType.NEW_ARRIVALS]: {
    title: Titles.TOP_PICKS_FOR_YOU,
    recommendedType: RecommendedType.USER_BASED,
    recommendationVariant: RecommendationVariants.TOP_PICKS,
    showLeftIcon: true,
    showSeeAll: true,
    showClose: false,
    endPoint: EndPoint.recommendation,
    pagename: '',
    sourceEvent: '',
  },

  [RecommendationType.RECOMMENDED_FOR_YOU]: {
    title: Titles.RECOMMENDED_FOR_YOU,
    recommendedType: RecommendedType.USER_BASED,
    recommendationVariant: RecommendationVariants.RECOMMENDED_FOR_YOU,
    showLeftIcon: true,
    showSeeAll: true,
    showClose: false,
    endPoint: EndPoint.recommendation,
    pagename: 'recommendedForYou',
    sourceEvent: 'recommendedForYouCarousel',
  },

  [RecommendationType.SEARCH_START_TOPPICKS]: {
    title: Titles.TOP_PICKS_FOR_YOU,
    recommendedType: RecommendedType.USER_BASED,
    recommendationVariant: RecommendationVariants.TOP_PICKS,
    showLeftIcon: true,
    showSeeAll: true,
    showClose: false,
    endPoint: EndPoint.recommendation,
    pagename: 'topPicksForYou',
    sourceEvent: 'topPicksForYouCarousel',
  },

  [RecommendationType.TOPPICKS]: {
    title: Titles.TOP_PICKS_FOR_YOU,
    recommendedType: RecommendedType.USER_BASED,
    recommendationVariant: RecommendationVariants.TOP_PICKS,
    showLeftIcon: true,
    showSeeAll: false,
    showClose: false,
    endPoint: EndPoint.recommendation,
    pagename: 'topPicksForYou',
    sourceEvent: 'topPicksForYouCarousel',
  },
};
